export class CookieKeys {
  static readonly channelRequestId = "channelRequestId";
  static readonly noCarOrDealerWarningClosed = "noCarOrDealerWarningClosed";
  static readonly consentPrefix = "consent_";
}

export class URLParamKeys {
  static readonly dealerNumber = "dealer";
  static readonly regNr = "regnr";
}

export class StockholmCenterCoordinates {
  static readonly lat = 59.334591;
  static readonly lng = 18.06324;
}
